module.exports = {
      id: "Arrow_Left-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/product/sprite.svg#Arrow_Left-usage",
      toString: function () {
        return this.url;
      }
    }